'use client';

import { sendGTMEvent } from '@next/third-parties/google';
import { useEffect } from 'react';

import type { FC } from 'react';

interface SendGtmEventProps {
  variant: 'content' | 'agent-form' | 'contact-one-model-form';
  eventData: Record<string, any>;
}

const SendGtmEvent: FC<SendGtmEventProps> = ({ variant, eventData }) => {
  let eventPayload = {};

  const arrayToPipedString = (array: string[]) => array.join('|');
  const formatModel = (model: string) => model.replace('template-', '');
  const formatPublishDate = (timestamp: string | number) => {
    const date = new Date(Number(timestamp));
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  switch (variant) {
    case 'content':
      eventPayload = {
        event: 'contentView',
        contentId: eventData.contentId || '',
        contentTitle: eventData.contentTitle || '',
        contentType: formatModel(eventData.contentType) || '',
        contentStatus: eventData.contentStatus || '',
        contentTags: eventData.contentTags || '',
        contentProviderType: eventData.contentProviderType ? arrayToPipedString(eventData.contentProviderType) : '',
        contentPublishDate: formatPublishDate(eventData.contentPublishDate) || '',
        contentSpecialties: eventData.contentSpecialties ? arrayToPipedString(eventData.contentSpecialties) : '',
      };
      break;
    case 'agent-form':
      eventPayload = {
        event: 'form_submit',
        formName: 'Agent Quote Form',
        formCoverageType: eventData.formCoverageType || '',
        formSpecialty: eventData.formSpecialty || '',
        formState: eventData.formState || '',
        formZip: eventData.formZip || '',
        formSubmitSuccessful: eventData.formSubmitSuccessful,
      };
      break;
    case 'contact-one-model-form':
      eventPayload = {
        event: 'form_submit',
        formName: 'Contact Form',
        formCoverageType: eventData.formCoverageType || '',
        formSpecialty: eventData.formSpecialty || '',
        formState: eventData.formState || '',
        formZip: eventData.formZip || '',
        formSubmitSuccessful: eventData.formSubmitSuccessful,
      };
      break;

    default:
      console.warn('sendGtmEvent called with unknown variant:', variant);
      break;
  }

  useEffect(() => {
    sendGTMEvent(eventPayload);
  }, []);

  return <></>;
};

export default SendGtmEvent;
